import { IconButton } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import { SnackbarProviderProps } from 'notistack';
import React, { RefObject } from 'react';

export const snackbarConfig = (providerRef: RefObject<any>): SnackbarProviderProps => ({
  variant: 'success',
  preventDuplicate: true,
  autoHideDuration: 3000,
  anchorOrigin: {
    horizontal: 'right',
    vertical: 'bottom',
  },

  action: (key: any) => (
    <IconButton
      style={{ color: '#fff' }}
      onClick={(evt: React.MouseEvent) => {
        evt.preventDefault();
        providerRef?.current.closeSnackbar(key);
      }}
    >
      <Close fontSize="inherit" color="inherit" />
    </IconButton>
  ),
});
